import BaseModel from "./base.model";

export default class PortDetailsModel extends BaseModel {

  port_number = false;
  number_to_port = null;
  network = null;
  account_type = null;

  constructor (data) {
    super();
    if (this.isEmpty(data)) return this;
    this.port_number = data.port_number;
    this.number_to_port = data.number_to_port;
    this.network = data.network;
    this.account_type = data.account_type;
  }
}
